module.exports = __webpack_public_path__ + "img/TikTok_logo@2x.41e01c79.png";